import __request__ from "routing/request";
export function multipleMetrics(nodeId, Requestedmetrics) {
  return __request__("POST", `/cluster/${nodeId}/metrics/multiple`, Requestedmetrics, {}, {
    "Accept": ["application/json"]
  });
}
export function metricNames(nodeId) {
  return __request__("GET", `/cluster/${nodeId}/metrics/names`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function byNamespace(nodeId, namespace) {
  return __request__("GET", `/cluster/${nodeId}/metrics/namespace/${namespace}`, null, {}, {
    "Accept": ["application/json"]
  });
}
